<template>
    <b-card :title="title">
        <b-card-body>
            <slot></slot>
            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        v-if="hasPermissionCreate"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orderTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            query: '',
            page: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                {
                    key: 'is_default',
                    label: 'Default',
                    formatter: value => (value ? 'Yes' : 'No'),
                },
                {
                    key: 'transaction_type',
                    label: 'Transaction Type',
                    formatter: value => (value || {}).name,
                },
            ],
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },
    },

    methods: {},
}
</script>
<style></style>
